import React, { useState } from "react";
import {
  Box,
  Typography,
  FormControl,
  Select,
  MenuItem,
  List,
  ListItemButton,
  ListItemText,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  InputLabel,
} from "@mui/material";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { formatInTimeZone } from "date-fns-tz";
import { duplicateEvent } from "../../../redux/features/adminEventsSlice";

const ImportEventModal = ({
  open,
  eventsHistory,
  handleClose,
  shows,
  rooms,
}) => {
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedShow, setSelectedShow] = useState("");
  const [selectedEvent, setSelectedEvent] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const closeDialog = async () => {
    await setSelectedShow("");
    await setSelectedRoom("");
    handleClose();
  };

  const handleConfirm = async () => {
    if (Boolean(selectedEvent)) {
      closeDialog();
      navigate("/events/duplicated");
      await dispatch(duplicateEvent({ eventId: selectedEvent }));
    }
  };

  const showLabel = Boolean(selectedShow) ? "Show" : "";
  const roomLabel = Boolean(selectedRoom) ? "Show" : "";

  let filteredEventsHistory = eventsHistory || [];
  if (Boolean(selectedShow)) {
    filteredEventsHistory = filteredEventsHistory.filter(
      ({ showId }) => showId === selectedShow,
    );
  }
  if (Boolean(selectedRoom)) {
    filteredEventsHistory = filteredEventsHistory.filter(
      ({ roomId }) => roomId === selectedRoom,
    );
  }

  return (
    <Dialog
      open={open}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      sx={{}}
      fullWidth
      maxWidth="md"
    >
      <DialogTitle id="alert-dialog-title">
        {"Select an event to copy"}
      </DialogTitle>
      <DialogContent>
        <Box
          display={"flex"}
          flexDirection={{ sm: "column", xs: "column", md: "row" }}
          gap={"20px"}
          sx={{
            marginTop: "20px",
          }}
        >
          <FormControl sx={{ flexGrow: "1" }}>
            <InputLabel shrink id="show-label">
              {showLabel}
            </InputLabel>
            <Select
              id="show-selector"
              name="show-selector"
              labelId="show-label"
              label={showLabel}
              displayEmpty
              value={selectedShow}
              onChange={(e) => {
                setSelectedShow(e.target.value);
              }}
            >
              {[
                <MenuItem key={`show-any`} value="">
                  <Typography color={"primary.lightText"}>Any Show</Typography>
                </MenuItem>,
                ...(shows || []).map(({ id, name }) => {
                  return (
                    <MenuItem key={`"show-${id}`} value={id}>
                      {name}
                    </MenuItem>
                  );
                }),
              ]}
            </Select>
          </FormControl>

          <FormControl sx={{ flexGrow: "1" }}>
            <InputLabel shrink id="room-label">
              {roomLabel}
            </InputLabel>
            <Select
              id="room-selector"
              name="room-selector"
              labelId="room-label"
              label={roomLabel}
              displayEmpty
              value={selectedRoom}
              onChange={(e) => {
                setSelectedRoom(e.target.value);
              }}
            >
              {[
                <MenuItem key={`room-any`} value="">
                  <Typography color={"primary.lightText"}>Any Room</Typography>
                </MenuItem>,
                ...(rooms || []).map(({ id, name }) => {
                  return (
                    <MenuItem key={`"room-${id}`} value={id}>
                      {name}
                    </MenuItem>
                  );
                }),
              ]}
            </Select>
          </FormControl>
        </Box>
        {filteredEventsHistory.length === 0 && (
          <Box textAlign={"center"} marginTop={"50px"}>
            <Typography color="text.disabled" variant="h3">
              No events found
            </Typography>
          </Box>
        )}
        <List>
          {(filteredEventsHistory || []).map((eventsHistoryItem) => {
            const { name, id: eventId, startsAt, timezone } = eventsHistoryItem;
            const dateTimePattern = "M/dd/yyyy, hh:mm a z";
            const dateText = formatInTimeZone(
              startsAt.toDate(),
              timezone,
              dateTimePattern,
            );

            return (
              <ListItemButton
                key={`import-event-${eventId}`}
                selected={selectedEvent === eventId}
                onClick={() => {
                  setSelectedEvent(eventId);
                }}
              >
                <Box sx={{ paddingTop: "20px", paddingBottom: "20px" }}>
                  <ListItemText
                    sx={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      display: "-webkit-box",
                      WebkitLineClamp: "3",
                      WebkitBoxOrient: "vertical",
                      marginTop: "0px",
                    }}
                    primary={name}
                  />
                  <Typography
                    marginTop={"10px"}
                    variant="body2"
                    sx={{ color: "primary.lightText" }}
                  >
                    {dateText}
                  </Typography>
                </Box>
              </ListItemButton>
            );
          })}
        </List>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!Boolean(selectedEvent)}
          onClick={handleConfirm}
          autoFocus
        >
          OK
        </Button>
        <Button onClick={closeDialog}> Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ImportEventModal;
